import React from "react";
import { ElementType, ExtractMixinProps } from "../../../lib/types/UtilTypes";

export interface BaseFocusBlockerProps<C extends ElementType = "div"> {
	tag?: C;
	active?: boolean;
	children?: React.ReactNode;
}

export type FocusBlockerProps<C extends ElementType> = ExtractMixinProps<
	BaseFocusBlockerProps<C>
>;

function FocusBlocker<C extends ElementType = "div">(
	props: FocusBlockerProps<C>,
) {
	const { active, children, tag, ...otherProps } = props;

	return React.createElement(
		tag || "div",
		{ ...otherProps, inert: active ? "true" : undefined },
		children,
	);
}

export default React.memo(FocusBlocker);
